<span class='cell-real-estate-mortgages-calculator_legend_item'>
	<span class='cell-real-estate-mortgages-calculator_legend_item-name'><%= name %></span>
	<span class='cell-real-estate-mortgages-calculator_legend_item-value'><%= y %></span>
	<% if (show_other_fees_sub_item) { %>
		<i class="fa fa-angle-up icon"></i>
	<% } else { %>
		<i class="fa fa-angle-down icon"></i>
	<% } %>
</span>
<% if (show_other_fees_sub_item) { %>
	<span class='cell-real-estate-mortgages-calculator_legend_sub_item first-item'>
		<span ><%= I18n.t('concepts.real_estate.mortgages.calculator.data.labels.commission.title') %></span>
		<span class='cell-real-estate-mortgages-calculator_legend_sub_item-value'><%= commission %></span>
	</span>
	<span class='cell-real-estate-mortgages-calculator_legend_sub_item'>
		<span>
      <%= I18n.t('concepts.real_estate.mortgages.calculator.data.labels.legal_fee') %>
    </span>
		<span class='cell-real-estate-mortgages-calculator_legend_sub_item-value'><%= legal_fee %></span>
	</span>
<% } %>
<hr>
<span class='cell-real-estate-mortgages-calculator_legend_item_part_two'>
	<span class='cell-real-estate-mortgages-calculator_legend_item-name'>
		<%= I18n.t('concepts.real_estate.mortgages.calculator.data.labels.loan_term') %>
	</span>
	<span class='cell-real-estate-mortgages-calculator_legend_item-value'>
		<%= I18n.t("concepts.real_estate.mortgages.calculator.data.labels.years_and_months", {year: years, month: months}) %>
	</span>
</span>
<span class='cell-real-estate-mortgages-calculator_legend_item_part_two'>
	<span class='cell-real-estate-mortgages-calculator_legend_item-name'>
		<%= I18n.t('concepts.real_estate.mortgages.calculator.data.labels.number_of_instalments') %>
	</span>
	<span class='cell-real-estate-mortgages-calculator_legend_item-value'><%= years * 12 + months%></span>
</span>
<span class='cell-real-estate-mortgages-calculator_legend_item_part_two'>
	<span class='cell-real-estate-mortgages-calculator_legend_item-name'>
		<%= I18n.t('concepts.real_estate.mortgages.calculator.data.labels.total_cost') %>
	</span>
	<span class='cell-real-estate-mortgages-calculator_legend_item-value'><%= total_cost %></span>
</span>
